import { useConfig } from "@/context/ConfigContext";
import { isBaseEcosystemEnabled } from "@/lib/baseFlags";
import BaseEcosystemPage from "@/pages/BaseEcosystemPage";
import NotFoundPage from "@/pages/NotFoundPage";

/** Route gate: build-time env OR backend /api/config flag. */
export default function BaseEcosystemGate() {
  const config = useConfig();
  if (config == null) {
    return <div className="min-h-screen bg-black" data-testid="base-ecosystem-loading" aria-hidden />;
  }
  if (!isBaseEcosystemEnabled(config)) {
    return <NotFoundPage title="Base ecosystem unavailable" />;
  }
  return <BaseEcosystemPage />;
}
